import { PropertySetModule } from "@/services/admin/property-set/modal"
import { PlusOutlined } from "@ant-design/icons"
import { Button, Input, Row, Space, Table } from "antd"
import classNames from "classnames"
import { useMemo, useState } from "react"
import { useOutletContext } from "react-router"
import { AddEditReaction } from "./AddEditReaction"
import { Equation } from "@/components/Equation/Equation"
import { deletePropertySetReactions } from "@/services/admin/property-set"
import { reactionTypeText } from "@/types/common"

export function PropertySetReactions() {
  const {propertySet, refresh} = useOutletContext<{propertySet: PropertySetModule.Modal, refresh: () => void}>();
  const [text, setText] = useState('')

  const filteredData = useMemo(() => {
    if (!text) return propertySet?.reactions || []
    return (propertySet?.reactions || []).filter(item => item.name.toLowerCase().includes(text.toLowerCase()))
  }, [propertySet?.reactions, text])

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
          return reactionTypeText[type] || '-'
      }
    },
    {
      title: 'Reaction Stoechiometry',
      dataIndex: 'type',
      key: 'type',
      render: (model, record) => {
        return <Equation components={propertySet.components} value={record.reactants}/>
      }
    },
    {
      title: 'Actions',
      dataIndex: 'Actions',
      key: 'Actions',
      render: (_, record) => {
        return <Space>
          <Button onClick={() => {
            AddEditReaction.show({
            reaction: record,
            onSuccess: () => {
              refresh()
            },
            propertySet
          })}}>Edit</Button>
          <Button onClick={async () => {
            await deletePropertySetReactions({
              setId: propertySet.id,
              id: record.id
            })
            refresh()
          }}>Delete</Button>
        </Space>
      }
    },
  ]
  return <div style={{width: '100%'}}>
    <Row justify={'space-between'}>
      <Input
        placeholder='Search by Name'
        style={{ width: 300 }}
        allowClear
        onChange={(event) => {
          setText(event.target.value)
        }}
      />
      <Button type='primary' icon={<PlusOutlined />} onClick={() => 
        AddEditReaction.show(
          {
            onSuccess: () => {
              refresh()
            },
            propertySet
          }
        )} >
        Create
      </Button>
    </Row>
    <div className={classNames('mt-2')}>
      <Table
        bordered
        rowKey={'id'}
        pagination={{ pageSize: 20, hideOnSinglePage: true }}
        size='small'
        columns={columns}
        dataSource={filteredData || []}
      />
    </div>
  </div>
}